import { connectApi } from '@app/api';
import { IGetTransactionsRequest } from '@app/api/types';
import { ITransaction } from '@features/workspace/types/banking';
import { IWithPagination } from '@features/workspace/types/generic';

/**
 * @description Transactions api handlers
 */
export const getTransactions = {
  key: 'getTransactions',
  executor: async (
    params: IGetTransactionsRequest
  ): Promise<IWithPagination<ITransaction[]>> => {
    const {
      data: { payload },
    } = await connectApi.transaction.getTransactions(params);

    return payload;
  },
};
